import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getOffsetPercentage } from '../utils';

const calcPoints = (vertical, marks, dots, step, min, max) => {
  const points = Object.keys(marks).map(parseFloat);
  if (dots) {
    for (let i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }
  return points;
};

const Steps = ({
  prefixCls, vertical, marks, getPointOffset, dots, step, included, lowerBound, upperBound, max, min, dotStyle, activeDotStyle,
}) => {
  const range = max - min;
  const elements = calcPoints(vertical, marks, dots, step, min, max).map((point) => {
    const offset = `${getOffsetPercentage({ point, getPointOffset, min, range, useAbs: true })}%`;

    const isActived = (!included && point === upperBound) || (included && point <= upperBound && point >= lowerBound);
    let style = vertical ? { bottom: offset, ...dotStyle } : { left: offset, ...dotStyle };
    if (isActived) {
      style = { ...style, ...activeDotStyle };
    }

    const pointClassName = classNames({
      [`${prefixCls}-dot`]: true,
      [`${prefixCls}-dot-active`]: isActived,
    });

    return <span className={pointClassName} style={style} key={point} />;
  });

  return <div className={`${prefixCls}-step`}>{elements}</div>;
};

Steps.propTypes = {
  prefixCls: PropTypes.string,
  activeDotStyle: PropTypes.object,
  dotStyle: PropTypes.object,
  min: PropTypes.number,
  max: PropTypes.number,
  upperBound: PropTypes.number,
  lowerBound: PropTypes.number,
  included: PropTypes.bool,
  dots: PropTypes.bool,
  step: PropTypes.number,
  marks: PropTypes.object,
  getPointOffset: PropTypes.func,
  vertical: PropTypes.bool,
};

export default Steps;
